// Centralized configuration - all URLs derived from env vars
const API_V1_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/api/v1';
const API_V2_URL = process.env.REACT_APP_API_V2_URL || 'http://localhost:5002/api/v2';
const _rawServerUrl = process.env.REACT_APP_SERVER_URL || API_V1_URL.replace('/api/v1', '');
// Normalize: always ensure trailing slash so concatenation is consistent
const SERVER_URL = _rawServerUrl.endsWith('/') ? _rawServerUrl : `${_rawServerUrl}/`;

/**
 * Resolve an asset path to a full URL.
 * Returns absolute URLs as-is, prefixes relative paths with SERVER_URL.
 */
const getAssetUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  // Strip leading slash from path since SERVER_URL already ends with /
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${SERVER_URL}${cleanPath}`;
};

export { API_V1_URL, API_V2_URL, SERVER_URL, getAssetUrl };
